import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class CommonService {

  private parentComponent = new Subject<any>();

  constructor(private _http: HttpClient) {
  }

  getMenuSectionList() {
    return this._http.get<any[]>('api/s/main/menu/section/list');
  }

  getMenuSubsectionItem(id: number) {
    return this._http.get<any[]>('api/s/main/menu/section/subsection/' + id);
  }

  getUserReportCategoryList() {
    return this._http.get<any[]>('api/a/report/category/list/by/user/role/true');
  }

  getInboxNewCount() {
    return this._http.get<any>('api/a/mail/inbox/new/count');
  }

  validateCaptcha(captchaId, captchaCode) {
    return this._http.get<any>('api/s/captcha/validate/' + captchaId + '/' + captchaCode);
  }

  getCaptcha() {
    return this._http.get('api/s/captcha/get');
  }

  sendCommandToParent(cmd: string, params?: any) {
    this.parentComponent.next({cmd: cmd, params: params});
  }

  getChildCommand(): Observable<any> {
    return this.parentComponent.asObservable();
  }

  showRestorePassword() {
    return this._http.get<any>('api/s/restore-password/showRestore');
  }

  showUserApplicationLink() {
    return this._http.get<any>('api/s/userApplication/showLink');
  }

  getAllPltModules() {
    return this._http.get<any>('api/pltmodule/all/list');
  }

  getAllPltRolesList() {
    return this._http.get<any>('api/pltroles/all/list');
  }

  getPasswordMinLength() {
    return this._http.get<any>('api/s/restore-password/passwordMinLength');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/services/common.service.ts